import { request } from "../utils/request";
import { versionfn } from "../utils/version";

var version = versionfn.version;

//查询链上安全研判知识库详情
export function knowledgeDetail(id) {
  return request({
    url: `${version}/help/knowledge/detail/${id}`,
    method: "get",
  });
}
//查询区块链案件侦查实录详情
export function expertServiceDetail(id) {
    return request({
      url: `${version}/help/expertService/blockchainCaseInvestigation/detail/${id}`,
      method: "get",
    });
  }
  //分页查询区块链案件侦查实录信息
export function expertServicePage(data) {
    return request({
      url: `${version}/help/expertService/blockchainCaseInvestigation/page`,
      method: "post",
      data,
    });
  }
    //分页查询链上安全研判知识库
export function knowledgePage(data) {
    return request({
      url: `${version}/help/knowledge/page`,
      method: "post",
      data,
    });
  }
  //知识库分类选项
export function knowledgeTypeOptions() {
    return request({
      url: `${version}/help/knowledge/type/options`,
      method: "get",
    });
  }
  //菜单信息
export function expertServiceMenu() {
    return request({
      url: `${version}/help/expertService/menu`,
      method: "get",
    });
  }
    //查询政策法规详情
export function policyRegulationDetail(id) {
    return request({
      url: `${version}/help/expertService/policyRegulation/detail/${id}`,
      method: "get",
    });
  }
      //分页查询政策法规信息
export function policyRegulationPage(data) {
    return request({
      url: `${version}/help/expertService/policyRegulation/page`,
      method: "post",
      data,
    });
  }